import React, { Component } from 'react';
import styled from 'styled-components';
import config from 'config';
import { Colors } from 'modules/theme';
import DropZone from 'components/DropZone';
import Table, { THeader, TableTitle, TRow, TableItem, TBody } from 'components/Table';
import H4 from 'components/H4';
import H5 from 'components/H5';
import ButtonText from 'components/ButtonText';
import AlertConfirm from 'components/AlertConfirm';
import Icon from 'components/Icon';
import Line from 'components/Line';
import PropTypes from 'prop-types';

const url = `${config.BASE_URL}/locations/import`;

const Container = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
  padding-bottom: 80px;
`;

const TableContainer = styled.div``;

const ErrorsContainer = styled.div`
  text-align: left;
`;

const ErrorContainer = styled.div`
  flex-direction: row;
  line-height: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding-bottom: 15px;
`;

const LineContainer = styled.div`
  margin-top: 30px;
`;

const FixedFooter = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: white;
  padding: 15px 30px;
  border-top: 1px solid ${Colors.gray2};
  display: flex;
  justify-content: flex-end;
  z-index: 10;
  @media (max-width: 767px) {
    padding: 12px 16px;
  }
`;

export default class LocationsForm extends Component {
  state = {
    locations: [],
    isOpenRedoAlert: false,
    isOpenNextAlert: false,
  };

  submit = () => {
    const { onSubmit } = this.props;
    const { locations } = this.state;

    const locationsApproved = locations.filter(location => !location.errors.length);

    onSubmit({ locations: locationsApproved }, 'Alerts Settings');
  };

  renderRodoAlert = () => {
    const { isOpenRedoAlert } = this.state;

    if (!isOpenRedoAlert) {
      return null;
    }

    return (
      <AlertConfirm
        title="Redo the import"
        onCancel={() => this.setState({ isOpenRedoAlert: false })}
        onSuccess={() => this.setState({ locations: [], isOpenRedoAlert: false, hasErrors: false })}
        successText="Remove"
        isVisible={isOpenRedoAlert}
      >
        <H4 style={{ textAlign: 'center' }}>Are you sure you want to redo the import?</H4>
      </AlertConfirm>
    );
  };

  renderNextAlert = () => {
    const { isOpenNextAlert } = this.state;

    return (
      <AlertConfirm
        title="Alert"
        onCancel={() => this.setState({ isOpenNextAlert: false })}
        onSuccess={() => {
          this.setState({ isOpenNextAlert: false }, () => {
            this.submit();
          });
        }}
        successText="Next"
        isVisible={isOpenNextAlert}
      >
        <H4 style={{ textAlign: 'center' }}>Are you sure you want continue with errors?</H4>
      </AlertConfirm>
    );
  };

  renderLocation = (location, key) => (
    <TRow key={key}>
      <TableItem style={{ minHeight: 130 }} width="15%">
        <H5 style={{ overflow: 'hidden' }}>{location.identificator}</H5>
      </TableItem>
      <TableItem style={{ minHeight: 130 }} width="20%">
        <H5 style={{ overflow: 'hidden' }}>
          {`${location.address_line}${
            location.address_line_1 ? ' ' : ''
          }${location.address_line_1 || ''},`}
        </H5>
        <H5 style={{ overflow: 'hidden' }}>{`${location.zip_code || ''}`}</H5>
      </TableItem>
      <TableItem style={{ minHeight: 130 }} width="15%">
        <H5 style={{ overflow: 'hidden' }}>
          {`${location.contact_first_name} ${location.contact_last_name}`}
        </H5>
      </TableItem>
      <TableItem style={{ minHeight: 130 }} width="15%">
        <H5 style={{ overflow: 'hidden' }}>{location.contact_email}</H5>
        <H5 style={{ overflow: 'hidden' }}>{location.contact_phone_number}</H5>
      </TableItem>
      <TableItem style={{ minHeight: 130 }} width="15%">
        <H5 style={{ overflow: 'hidden' }}>
          {`${location.installer_first_name} ${location.installer_last_name}`}
        </H5>
      </TableItem>
      <TableItem style={{ minHeight: 130 }} width="20%">
        {location.errors && location.errors.length ? (
          <ErrorsContainer>
            {location.errors.map((error, key) => (
              <ErrorContainer key={key}>
                <Icon
                  name="exclamation-circle"
                  color={Colors.red}
                  customStyle={{ marginRight: '10px' }}
                />
                {error}
              </ErrorContainer>
            ))}
          </ErrorsContainer>
        ) : (
          <Icon name="check-circle" fontSize={25} color={Colors.green} />
        )}
      </TableItem>
    </TRow>
  );

  handleResponse = locations => {
    const hasErrors =
      locations.findIndex(location => location.errors && location.errors.length) !== -1;
    this.setState({ locations, hasErrors });
  };

  render() {
    const { locations, hasErrors } = this.state;
    const { back, token, dropzoneTitle } = this.props;

    return (
      <Container>
        {locations.length ? (
          <TableContainer>
            <ButtonContainer>
              <ButtonText
                theme="text"
                icon="redo"
                text="Redo Import"
                onClick={() => this.setState({ isOpenRedoAlert: true })}
              />
            </ButtonContainer>
            <Table>
              <THeader>
                <TableTitle width="15%">Name</TableTitle>
                <TableTitle width="20%">Address</TableTitle>
                <TableTitle width="15%">Phone #</TableTitle>
                <TableTitle width="15%">Admin</TableTitle>
                <TableTitle width="15%">Contact</TableTitle>
                <TableTitle width="20%">Status</TableTitle>
              </THeader>
              <TBody>{locations.map((account, key) => this.renderLocation(account, key))}</TBody>
            </Table>
          </TableContainer>
        ) : (
          <DropZone
            token={token}
            url={url}
            title={dropzoneTitle}
            handleResponse={this.handleResponse}
            link={config.LOCATIONS_CSV_EXAMPLE_URL}
          />
        )}
        <LineContainer>
          <Line />
        </LineContainer>

        <FixedFooter>
          <ButtonText
            text="Back"
            type="button"
            theme="default"
            customStyles={{ marginRight: '20px' }}
            onClick={() => back('Details')}
          />
          <ButtonText
            text={`Save ${hasErrors ? ', with errors' : ''}`}
            theme="primary"
            onClick={() => (hasErrors ? this.setState({ isOpenNextAlert: true }) : this.submit())}
          />
        </FixedFooter>

        {this.renderRodoAlert()}
        {this.renderNextAlert()}
      </Container>
    );
  }
}

LocationsForm.propTypes = {
  back: PropTypes.func,
  dropzoneTitle: PropTypes.string,

  onSubmit: PropTypes.func,
  token: PropTypes.string,
};
